import { Text } from '@chakra-ui/react';
import Widget from './Widget';
import { CircleIndicator } from '../indicators';
import { useTemporaryTrafficManagementKpi } from '../../context/temporary-traffic-management-api-hooks';
import { roundKpiValue } from '../../shared/helpers';
import useHasAccess from '../../hooks/useHasAccess';

export default function TemporaryTrafficManagementWidget() {
  const { data: ttmData, isLoading, isError } = useTemporaryTrafficManagementKpi();

  // Check if user has any of the allowed roles for the selected RCA
  const hasAccess = useHasAccess();

  const title = 'Temporary Traffic\nManagement';
  const description = 'Proportion of year to date maintenance\n& improvement expenditure (%)';

  // If there is an error we want to hide the widget
  if (isError) return null;

  return (
    <Widget
      link={hasAccess ? '/performance/dashboard/temporary-traffic-management' : null}
      title={title}
      description={description}
      lockYear={ttmData?.quadLockYear}
      quarter={ttmData?.quarter}
      quarterFormat="ytd"
      isLoading={isLoading && !ttmData}
      moreInfoContent={
        <Text fontSize="sm">The proportion of year to date Temporary Traffic Management expenditure compared to all year to date maintenance and improvement expenditure.</Text>
      }
    >
      <CircleIndicator
        size={100}
        colour={ttmData?.value !== undefined ? 'gray.700' : null}
        value={ttmData?.value !== undefined ? `${roundKpiValue(ttmData?.value, 7, 1)}%` : undefined}
        isLoading={isLoading || !ttmData}
      />
    </Widget>
  );
}
